import { PlayerCache } from "./player/PlayerCache";
var BPMSoundsGeneric = /** @class */ (function () {
    function BPMSoundsGeneric() {
    }
    BPMSoundsGeneric.initialize = function (options) {
        BPMSoundsGeneric.options = options;
        if (options.disableCaching) {
            PlayerCache.ENABLED = false;
        }
    };
    BPMSoundsGeneric.get = function () {
        return BPMSoundsGeneric.options;
    };
    return BPMSoundsGeneric;
}());
export { BPMSoundsGeneric };
//# sourceMappingURL=generic.js.map